import axios from '_u/axios'
import { yuan, cent } from '_u/helper'

// 设施列表
export const assetsFacilityList = (body) => {
    return axios.post('api/assets/facility/list', body)
}

// 设施列表 noChildren
export const assetsFacilityListNoChildren = (body) => {
    return axios.post('api/assets/facility/listNoChildren', body)
}

// 设施新增
export const assetsFacilityAdd = (body) => {
    return axios.post('api/assets/facility/add', body)
}

// 设施查看
export const assetsFacilityView = (id) => {
    return axios.post('api/assets/facility/view', { id })
}

//设施更新
export const assetsFacilityUpdate = (body) => {
    return axios.post('api/assets/facility/update', body)
}

// 设施删除
export const assetsFacilityDelete = (id) => {
    return axios.post('api/assets/facility/delete', { id })
}

// 楼栋列表
export const assetsFloorList = (body) => {
    return axios.post('api/assets/floor/list', body)
}
// 楼栋新增
export const assetsFloorAdd = (body) => {
    return axios.post('api/assets/floor/add', body)
}

// 楼栋查看
export const assetsFloorView = (id) => {
    return axios.post('api/assets/floor/view', { id })
}

//楼栋更新
export const assetsFloorUpdate = (body) => {
    return axios.post('api/assets/floor/update', body)
}

// 楼栋删除
export const assetsFloorDelete = (id) => {
    return axios.post('api/assets/floor/delete', { id })
}

// 房间列表
export const assetsHouseList = (body) => {
    return axios.post('api/assets/house/list', body)
}
// 房间新增
export const assetsHouseAdd = (body) => {
    return axios.post('api/assets/house/add', body)
}

// 房间查看
export const assetsHouseView = (id) => {
    return axios.post('api/assets/house/view', { id })
}

//房间更新
export const assetsHouseUpdate = (body) => {
    return axios.post('api/assets/house/update', body)
}

//房间合并
export const assetsHouseMerge = (body) => {
    return axios.post('api/assets/house/merge', body)
}

//房间拆分
export const assetsHouseSplit = (body) => {
    return axios.post('api/assets/house/split', body)
}

// 房间删除
export const assetsHouseDelete = (id) => {
    return axios.post('api/assets/house/delete', { id })
}
// 房间解锁/锁定
export const assetsHouseLocking = (houseId) => {
    return axios.post('api/assets/house/locking', { houseId })
}
// 批量修改房间
export const updateBatch = (body) => {
    return axios.post('api/assets/house/updateBatch', body)
}

// 批量删除房间
export const delBatch = (houseIds) => {
    return axios.post('api/assets/house/delBatch', { houseIds })
}

// 房间代码生成
export const assetsHouseNo = (body) => {
    return axios.post('api/assets/house/genHouseNo', body)
}

// 房产树形结构
export const assetsTreeList = (body) => {
    return axios.post('api/assets/house/treeList', body)
}

// 预定新增
export const assetsBookAdd = (body) => {
    return axios.post('api/contract/housereserve/add', body)
}

//预定更新
export const assetsBookUpdate = (body) => {
    return axios.post('api/contract/housereserve/update', body)
}

// 预定查看
export const assetsBookView = (id) => {
    return axios.post('api/contract/housereserve/queryByHouseId', { id })
}

// 预定终止
export const assetsBookStop = (body) => {
    return axios.post('api/contract/housereserve/stop', body)
}

// 出租记录
export const assetsRentalRecords = (body) => {
    return axios.post('api/assets/houserent/list', body)
}

// 出租记录物品清单
export const assetsRentalFacility = (id) => {
    return axios.post('api/contract/info/facility', { id })
}

// 房源关联明细数据
export const houseRelDetail = (id) => {
    return axios.post('api/assets/house/houseRelDetail', { id })
}

// 房间密码
export const queryWifiPwd = (houseId) => {
    return axios.post('api/assets/house/queryWifiPwd', { houseId })
}

// 根据楼层查询房间
export const houseListByFloorNum = (body) => {
    if (typeof body === 'string') {
        body = { floorId: body }
    }
    return axios.post('api/assets/house/houseDetailList', body)
}

// 批量改价格
export const updateBatchFee = (houseList) => {
    return axios.post('api/assets/house/updateBatchFee', {
        houseList,
    })
}

// 批量修改房间数据
export const updateBatchNew = (body) => {
    // 佣金
    if (body.commission) body.commission = cent(body.commission)
    // 房间配置
    if (body.facilitys !== undefined) {
        body.facilitys = body.facilitys || []
        body.facilitys.forEach((v) => (v.price = cent(v.price)))
        body.facilitys = JSON.stringify(body.facilitys)
    }
    // 其它费用
    if (body.otherFee !== undefined) {
        body.otherFee = body.otherFee || []
        body.otherFee.forEach((v) => (v.amount = cent(v.amount)))
        body.otherFee = JSON.stringify(body.otherFee)
    }
    // 其它押金
    if (body.otherDeposit !== undefined) {
        body.otherDeposit = body.otherDeposit || []
        body.otherDeposit.forEach((v) => (v.amount = cent(v.amount)))
        body.otherDeposit = JSON.stringify(body.otherDeposit)
    }
    // 标签
    if (body.tags !== undefined) {
        body.tags = body.tags.join(',')
    }

    return axios.post('api/assets/house/updateBatchNew', body)
}

// 营销房源列表
export const marketRoomList = (body) => {
    return axios
        .post('api/assets/housepublish/publishList', body)
        .then((res) => {
            var list = res.data.page.list

            list.forEach((v) => {
                v.rent = yuan(v.rent)
                v.commission = yuan(v.commission)
            })

            return res
        })
}

// 营销房源上架
export const marketRoomPublish = (body) => {
    if (typeof body === 'string') {
        body = { ids: body }
    }
    return axios.post('api/assets/housepublish/publish', body)
}

// 营销房源下架
export const marketRoomUnPublish = (body) => {
    if (typeof body === 'string') {
        body = { ids: body }
    }
    return axios.post('api/assets/housepublish/unpublish', body)
}

// 营销房源上架预校验
export const marketRoomCheckPublish = (body) => {
    if (typeof body === 'string') {
        body = { ids: body }
    }
    return axios.post('api/assets/housepublish/validPublish', body)
}

// 营销房源上架预校验
export const validPublishOfZwzhao = (body) => {
    if (typeof body === 'string') {
        body = { ids: body }
    }
    return axios.post('api/assets/housepublish/validPublishOfZwzhao', body)
}


// 发布房源到找房
export const pubHouseToZwZhao = (body) => {
    return axios.post('/api/assets/housepublish/publishZwZhao',body)
}


// 批量发布房源到找房  220119最新进度
export const batchPublishZwZhao = (body) => {
    if (typeof body === 'string') {
        body = { houseIds: body }
    }
    return axios.post('/api/assets/housepublish/batchPublishZwZhao',body)
}


// 从找房端下架房源
export const unPubHouseToZwZhao = (body) => {
    return axios.post('/api/assets/housepublish/unPublishZwZhao',body)
}

// 更新房源全量信息到找房
export const updateToZwZhao = (body) => {
    return axios.post('/api/assets/housepublish/updateToZwzhao',body)
}



